export default "__VITE_ASSET__c0de7773__"